module.exports = __webpack_public_path__ + "static/img/60-1.6a3e89c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/60-1.jpg
// module id = djGM
// module chunks = 0